import {
    Card,
    Container,
    Table,
    TableContainer,
    TablePagination,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import DataTableRow from '@src/components/data-table/data-row';
import TableHeader from '@src/components/data-table/header';
import Scrollbar from '@src/components/scrollbar';
import { TABLE_HEAD_GOLD_PURCHASE, TABLE_HEAD_PURCHASE } from '@src/utils/mockdata/table-headers';

import { usePurchasesService } from '../hooks';
import { usePurchasesContext } from '../provider';
import TableRowItem from './table-row';
import Toolbar from './toolbar';
import { useMemo } from 'react';

const Body = () => {
	const location = useLocation();
	const { data, purchases, isLoading, isRefreshing } = usePurchasesService();
	const { state, handlePageChange, handleRequestSort, handleRowsPerPageChange } = usePurchasesContext();

	const HEADER_TABLE = useMemo(() => {
		if(location.pathname === "/dashboard/purchase/gold-purchases") return TABLE_HEAD_GOLD_PURCHASE;
		return TABLE_HEAD_PURCHASE;
	},[location.pathname]);

	return (
		<Container>
			<Toolbar />
			<Card sx={{borderRadius: "25px", px: "23px", py: "10px"}}>
				<Scrollbar>
					<TableContainer sx={{ overflowX: 'auto' }}>
						<Table>
							<TableHeader
								order={state.order}
								orderBy={state.orderBy}
								headLabel={HEADER_TABLE}
								onRequestSort={handleRequestSort}
							/>
							<DataTableRow
								colSpan={9}
								data={purchases}
								isLoading={isLoading}
								isRefreshing={isRefreshing}
								headers={HEADER_TABLE}
								filterName={state.filterName}
								renderItem={({ item, index }: any) => {
									return (
										<TableRowItem
											key={`${index}`}
											{...item}
										/>
									)
								}}
							/>
						</Table>
					</TableContainer>
				</Scrollbar>

				<TablePagination
					rowsPerPageOptions={[10, 25, 50]}
					page={(state.page || 0)}
					component="div"
					rowsPerPage={state.rowsPerPage || 10}
					count={data?.totalRecords ?? 0}
					onPageChange={handlePageChange}
					onRowsPerPageChange={handleRowsPerPageChange}
				/>
			</Card>
		</Container>
	)
}

export default Body